import React, { useState } from 'react'
import { Link } from 'react-router-dom';
import { SignUpChoiceModal } from './SignUpChoiceModal';

function RightSideBanner() {
  const [smShow, setSmShow] = useState(false);
  return (
    <>
      <SignUpChoiceModal show={smShow} onHide={() => setSmShow(false)} />
      <div className='item-bg-login'>
     

        <div className='banner-content text-center'>
          <div>
            <Link to="/Home"> <img src='../image/logo1.png' /></Link>

            <h1>PLAY AND WIN </h1><br /><br />
            {/* #277: a button, so it looks and works like one (pointer, Tab, Enter / Space). The
                words are part of the picture. */}
            <button type='button' className='register-now' onClick={() => setSmShow(true)}>
              <img src='../image/button.png' alt='Register now' />
            </button>
          </div>
        </div>

      </div>
    </>
  )
}

export default RightSideBanner